import { render, staticRenderFns } from "./YHBottom.vue?vue&type=template&id=37f6d6c0&"
import script from "./YHBottom.vue?vue&type=script&lang=js&"
export * from "./YHBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f6d6c0')) {
      api.createRecord('37f6d6c0', component.options)
    } else {
      api.reload('37f6d6c0', component.options)
    }
    module.hot.accept("./YHBottom.vue?vue&type=template&id=37f6d6c0&", function () {
      api.rerender('37f6d6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/YHBottom.vue"
export default component.exports